export const SLSO = 'slso'
export const ID = 'id'
export const CLASSLAB = 'classlab'
export const CS = 'cs'
export const CONTENT = 'content'
export const LAB = 'lab'
